import { AutoAwesome } from "@mui/icons-material"
import intl from "src/internationalization/intl"
import { Grid, IconButton, Typography } from "../../basics"
import { BoxCard } from "../../basics/BoxCard"
import { IOverviewCardProps } from "./types"

const OverviewCard = (props: IOverviewCardProps) => {
    return (
        <BoxCard sx={{ width: 'fit-content', minWidth: props.minWidth }}>
            <Grid container gap={2} justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Grid container gap={1} justifyContent="flex-start">
                        <Grid item>
                            {props.icon}
                        </Grid>
                        <Grid item>
                            <Typography variant="h4">
                                {props.title}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    {props.headerAction}
                    <IconButton variant="clean" color="primary">
                        <AutoAwesome />
                    </IconButton>
                </Grid>
            </Grid>
            <Grid sx={{ mt: 2 }}>
                <Grid item>
                    <Typography variant="h1">
                        {props.clientsNumber}
                    </Typography>
                    <Typography variant="caption">
                        {intl("impactedClients")}
                    </Typography>
                </Grid>
                <Grid item sx={{ mt: 1 }}>
                    <Typography variant="h1">
                        {props.totalAmount}
                    </Typography>
                    <Typography variant="caption">
                        {intl("totalAmount")}
                    </Typography>
                </Grid>
            </Grid>
            {props.footer}
        </BoxCard>
    )
}

export { OverviewCard }

